import "../Styles/index.scss";

import { initializeMaps } from "@wagich/bluc-map";
initializeMaps();

import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox], .is-zoomable", {
	hideScrollbar: false,
});

import tippy from "tippy.js";
tippy("[data-tippy-content]");

const dropdowns = document.querySelectorAll<HTMLElement>(".dropdown:not(.is-hoverable)");
if (dropdowns.length > 0) {
	for (let element of dropdowns) {
		element.addEventListener("click", (event) => {
			event.stopPropagation();
			element.classList.toggle("is-active");
		});
	}
	document.addEventListener("click", (event) => {
		for (let element of dropdowns) {
			element.classList.remove("is-active");
		}
	});
}

import Flickity from "flickity";
for (let element of document.querySelectorAll<HTMLElement>(".asset-list--image")) {
	new Flickity(element, {
		pageDots: false,
	});
}

import { Accordion } from "./accordion";
for (let element of document.querySelectorAll<HTMLDetailsElement>("details")) {
	new Accordion(element);
}

document.querySelector(".header__nav-toggle")?.addEventListener("click", () => {
	document.documentElement.classList.toggle("is-nav-open");
});

let headers = document.querySelectorAll(".header");
let isHeaderCollapsed = false;
function headerScrollHandler(e: Event) {
	if (!isHeaderCollapsed && window.scrollY > 60) {
		isHeaderCollapsed = true;
		for (let element of headers) {
			element.classList.add("is-collapsed");
		}
	}
	if (isHeaderCollapsed && window.scrollY <= 60) {
		isHeaderCollapsed = false;
		for (let element of headers) {
			element.classList.remove("is-collapsed");
		}
	}
}

function openDesktopSubmenu(e: MouseEvent) {
	let target = e.target as HTMLElement;
	let item = target.parentElement!;
	for (let otherItem of document.querySelectorAll(".nav-item.level-1")) {
		if (otherItem === item) {
			continue;
		}
		otherItem.classList.remove("is-open");
	}
	item.classList.toggle("is-open");
}
function closeDesktopSubmenu(e: MouseEvent) {
	let target = e.target as HTMLElement;
	if (!target.closest(".nav-item.level-1.is-open")) {
		document.querySelector(".nav-item.level-1.is-open")?.classList.remove("is-open");
	}
}

window.addEventListener("scroll", headerScrollHandler);


for (let element of document.querySelectorAll<HTMLElement>(".nav-link.level-1")) {
	element.addEventListener("click", openDesktopSubmenu);
}
document.addEventListener("click", closeDesktopSubmenu);


for (let element of document.querySelectorAll("a[href^='mailto'],a[href^='tel']")) {
	element.addEventListener("click", e => {
		try {
			plausible("Kontaktlink aktiviert");
		} catch { }
	});
}
